'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuiteCalcCTAsContainer = function SuiteCalcCTAsContainer(props) {
  return _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcAuthedCTAs');
    },
    publicComponentLoader: function publicComponentLoader() {
      return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton');
    },
    authedComponentProps: _extends({}, props),
    publicComponentProps: {
      use: 'primary-white',
      nonMerchandiseIdProduct: 'growth' + props.edition,
      sourceId: 'pricing-middle'
    }
  });
};

SuiteCalcCTAsContainer.propTypes = {
  edition: _react.PropTypes.string.isRequired
};

exports.default = SuiteCalcCTAsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcCTAsContainer.js
// module id = 781
// module chunks = 3 4